import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { IconChevronLeft, IconChevronRight } from '@pentabd/icons';

import Text from '../../text/Text';
import { Button } from '../../button';
import { SELECT_VIEW } from './constant';

const YEAR_RANGE = 10;

interface Props {
  onSelectYear: (data: number) => void;
  setActiveSelectView?: (data: string) => void;
  displayDate: Dayjs;
  onClickYear?: (data: number) => void;
  setIsOpen?: (data: boolean) => void;
  isYearPicker?: boolean;
}

const PopulateYears = ({
  onSelectYear,
  setActiveSelectView,
  displayDate,
  onClickYear,
  setIsOpen,
  isYearPicker,
}: Props) => {
  const [startYear, setStartYear] = useState(dayjs().get('year') - 10);
  const displayYear = displayDate.get('year');
  const years = [];

  for (let i = startYear; i <= startYear + 10; ++i) {
    years.push(
      <Button
        type={displayYear === i ? 'primary' : 'default'}
        key={i}
        className="p-4"
        onClick={() => {
          onSelectYear(i);
          onClickYear && onClickYear(i);
          isYearPicker && setIsOpen && setIsOpen(false);
        }}
      >
        {i}
      </Button>,
    );
  }
  return (
    <div className="px-8">
      <div className="d-flex justify-content-between align-items-center mb-8">
        <div
          className="pointer"
          onClick={() => setStartYear((year) => year - YEAR_RANGE)}
        >
          <IconChevronLeft size={20} />
        </div>

        <Text size="md" color="dark">
          {startYear} -- {startYear + YEAR_RANGE}
        </Text>

        <div
          className="pointer"
          onClick={() => setStartYear((year) => year + YEAR_RANGE)}
        >
          <IconChevronRight size={20} />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex flex-wrap">{years}</div>

        {setActiveSelectView ? (
          <Button
            type="danger"
            onClick={() => setActiveSelectView(SELECT_VIEW.DATE)}
          >
            Close
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default PopulateYears;
